import React, { Component } from "react";

import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Hidden from "material-ui/Hidden";

class PriceList extends Component {
  render() {
    return (
      <div className="priceList">
        <Grid container spacing={24} justify="center">
          <Grid item xs={10} sm={10} md={10} lg={8}>
            <div className="priceListInnerContainer">
              <Typography variant="headline">
                Važeći cenovnik Poliklinike Sente možete preuzeti{" "}
                <a
                  href="https://docs.google.com/document/d/1gmUS-67DwAyGoHFXvnOTMSjd8LkT8QOQ/edit?usp=sharing&ouid=101740924393115787530&rtpof=true&sd=true"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ovde
                </a>
              </Typography>

              <Typography variant="body2" align="justify">
                U saradnji sa laboratorijom Medlab vršimo i uzimanje uzoraka
                krvi za sve analize koje su potrebne radi utvrđivanja vašeg
                zdravstvenog stanja, kao i briseve grla, uha, nosa, vaginalnog
                sekreta i citološkog pregleda (PAPA test). Cenovnik Medlab
                laboratorije možete preuzeti{" "}
                <a
                  href="https://www.medlab.rs/cenovnik/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ovde
                </a>
              </Typography>
              <Hidden mdDown>
                <iframe title="cenovnik" src="https://docs.google.com/document/d/e/2PACX-1vQFpnO7P203r2fnYMw61cD8Ozf1Uy8tmL_oOLLLyj1esjOD78fJGIkSxrtXheKcRA/pub?embedded=true">
                  This browser does not support documents. Please download the
                  document to view it:{" "}
                  <a href="https://docs.google.com/document/d/e/2PACX-1vQFpnO7P203r2fnYMw61cD8Ozf1Uy8tmL_oOLLLyj1esjOD78fJGIkSxrtXheKcRA/pub">
                    Open document
                  </a>
                </iframe>
              </Hidden>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default PriceList;



// WEBPACK FOOTER //
// ./src/components/PriceList.js